<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="仓库编号">
					<c-input name="warehouse_code"></c-input>
				</m-search-item>
				<m-search-item label="仓库名称">
					<c-input name="warehouse_name"></c-input>
				</m-search-item>
				<m-search-item label="状态">
					<c-select name="warehouse_state" multiple :options="disableEnableDic"></c-select>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_warehouse_edit')" prepend-icon="tf-add" @click="editWarehouse()">创建仓库</c-button>
				
				<template #batch>
					<c-button v-if="auth('b_warehouse_print')" prepend-icon="tf-print" @click="batchExportByTemplate">打印</c-button>
					<c-button v-if="auth('b_warehouse_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveWarehouse">删除</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow" >
				<c-table-column
				    type="selector"
				    width="32"
					@handle="batchSelect"
				></c-table-column>

				<c-table-column
					label="仓库编号"
					name="warehouse_code"
					width="150"
				>
				</c-table-column>

				<c-table-column
					label="仓库名称"
					name="warehouse_name"
					width="150"
				>
				</c-table-column>

				<c-table-column
					label="备注说明"
					name="remark"
					width="300"
				>
				</c-table-column>

				<c-table-column
					label="状态"
					name="warehouse_state"
					width="80"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_warehouse_edit')" v-model="data.warehouse_state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.warehouse_state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="是否默认"
					name="is_default"
					width="90"
				>
					<template #default="{data}">
						<c-link v-if="auth('b_warehouse_edit') && data.is_default == 1" @click="isDefaultHandle(data)">设为默认</c-link>
						<c-state v-else dict="defaultDic" :value="data.is_default"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="仓库管理员"
					name="role_names"
					width="200"
				>
					<template #default="{data}">
						<span v-if="!data.manager_user_realnames">-</span>
						<c-tags v-else :value="data.manager_user_realnames"></c-tags>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="160"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_warehouse_edit')" icon="tf-edit" @click="editWarehouse(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_warehouse_print')" icon="tf-print" @click="exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_warehouse_edit')" :disabled="!(data.is_default == 1)" icon="tf-trash" color="red" @click="removeWarehouse(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--编辑仓库信息弹窗-->
			<warehouse-edit ref="warehouseEdit" @resolve="$refs.list.update()"></warehouse-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import warehouseEdit from "@/pages/basic/warehouse_edit.vue";
	import {batchData, batchMethods} from '@/components/public/batch.js'

	export default {
		components: {warehouseEdit},
		computed: {
			// 获取dictName选项数据
			...mapState(['disableEnableDic']),
		},
		props: {
			type: String
		},

		data() {
			return {
				...batchData(),
				workType: 26,
				view_id: 26
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			...batchMethods(),

			/********搜索************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/warehouse/list',
					data,
					success: () => {
						this.batchData = [];
					}
				});
			},

			/******新建/编辑仓库*******/
			editWarehouse(data) {
				this.$refs.warehouseEdit.open(data);
			},

			/******仓库启禁用*********/
			stateHandle(state, next, data) {
				if (data.is_default == 2) {
					this.$message({
						message: '默认仓库无法禁用'
					});
					return;
				}
				this.request({
					url: '/warehouse/edit/state',
					data: {
						id: data.id,
						warehouse_state: state ? 2 : 1
					},
					success: () => {
						next();
					}
				})
			},

			/******仓库设置默认*********/
			isDefaultHandle(data) {
				if (data.warehouse_state == 2) {
					this.$message({
						message: '请先启用仓库'
					});
					return;
				}
				this.request({
					url: '/warehouse/set/default',
					data: {
						id: data.id
					},
					success: () => {
						this.$refs.list.update();
					}
				})
			},

			/****批量删除仓库***/
			batchRemoveWarehouse(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条仓库记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/warehouse/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/******删除仓库***********/
			removeWarehouse(data){
				this.$confirm({
					message:'确认删除仓库【'+data.warehouse_name+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/warehouse/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/********【通过模板】批量导出********/
			batchExportByTemplate(){
				var data = this.$refs.list.getRow('selected');
				var idList = data.map(item => {
					return item.data.id;
				});
				this.exportByTemplate(idList.join(','));
			},

			/******通过Excel模板导出数据*******/
			exportByTemplate(ids) {
				//打开模板选择弹窗
				this.globalDialog('exportTemplateSelector', {
					props: {
						workType: this.workType
					},
					data: {
						htmlParams: Object.assign({
							ids,
							export_type: 2,
							view_id: this.view_id
						}, this.$refs.search.get())
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>